import { Injectable, signal, computed } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PrimeNG } from 'primeng/config';
import {Constants} from '../helpers/constants'

@Injectable({
  providedIn: 'root',
})
export class LanguageService2 {
  locale: any;

  constructor(private primengConfig: PrimeNG, private translate: TranslateService) {
    this.initLanguage();
  }

  initLanguage() {
    this.locale = Constants.getLang() === 'ko' ? Constants.koreanLocale : Constants.getLang() === 'vi' ? Constants.vietnamLocale : Constants.englishLocale;
    this.primengConfig.setTranslation(this.locale);
  }

  setLanguage(lang: string) {
    this.translate.use(lang);
    this.locale = lang === 'ko' ? Constants.koreanLocale : lang === 'vi' ? Constants.vietnamLocale : Constants.englishLocale;
    this.primengConfig.setTranslation(this.locale);
  }

  getLocale() {
    return this.locale;
  }
}
